<template>
    <ui-modal name="thank-feedback-modal">
        <template>
            <div class="content-thank-feedback-modal">
                <i class="fal fa-laugh-beam"></i>

                <span class="title">
                    Obrigado pelo Feedback. Assim você constrói um Facilita cada vez melhor para você!
                </span>

                <ui-button design="primary md mw-100" @click="close">Fechar</ui-button>
            </div>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiButton } from '@/components/ui/buttons'

    export default {
        name: 'ui-feedback-modal',

        components: {
            uiModal,
            uiButton
        },

        methods: {
            close() {
                this.$root.$emit('modal-close-thank-feedback-modal')
            }
        },

        mounted() {
            this.$root.$on('modal-open-thank-feedback-modal', () => {})
        },

        beforeDestroy() {
            this.$root.$off('modal-open-thank-feedback-modal')
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>